module.exports = __webpack_public_path__ + "static/media/format_heading-two.605200c0.svg";